import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface AlertModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function AlertModal ({ isOpen, onClose }: AlertModalProps) {

  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      navigate("./#thanks");
    } else {
      document.body.style.overflow = 'unset';
      navigate("./");
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 overflow-y-auto pt-8 pb-8">
      <div className="bg-white rounded-xl max-w-2xl w-full relative p-8">
        <label className="block text-xl font-bold text-gray-700 mb-2">
          お問合せ完了
        </label>
        <label className="text-gray-600">
          お問合せを受け付けました。
        </label>
        <div className="pt-5">
          <button className="group bg-blue-600 text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
    </>
  );
}